<template>
	<AppModal id="mfa-validation-modal" @close="close">
		<div class="mfa-modal-header">
			<h3 class="text-bold mb-2">Verify Code</h3>
			<p class="modal-pretext">
				Enter the one-time code from "{{ this.configName === '' ? 'authenticator app' : this.configName }}" to complete authentication
			</p>
		</div>
		<OTPInput
			:error="error"
			:warning="warning"
			:state-change-key="stateChangeKey"
			@resetErrors="resetWarningsAndErrors"
			@otp="otp = $event"
			submit-button-text="Continue"
			@submit="validateConfigOTP"
		/>
	</AppModal>
</template>
<script>
	import { mapActions } from 'vuex'
	/* eslint-disable import/extensions */
	import { configSettings } from '~/plugins/config-settings.js'
	import axios from 'axios'
	import helper from '~/global_helper/helpers.js'
	import CONSTANTS from '../../global_helper/constants'

	export default {
		props: {
			nextRoute: String,
			token: String,
			configName: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				ajaxWarnings: {},
				ajaxError: {
					message: '',
					status: null,
					errors: {},
				},
				form: {},
				loading: false,
				stateChangeKey: 0,
				size: 300,
				ttlDays: CONSTANTS.MFA.DEFAULT_TTL_DAYS,
				formStatus: false,
				otp: '',
			}
		},
		computed: {
			error() {
				return (this.ajaxError && this.ajaxError.errors && this.ajaxError.errors.otp) || []
			},
			warning() {
				return this.ajaxWarnings && this.ajaxWarnings.otp
			},
			isOtpValid() {
				return helper.validateMFACodeFormat(this.otp?.trim())
			},
		},
		methods: {
			...mapActions('Auth', ['saveToken']),
			async updateTokenAfterCodeVerification(newToken) {
				await this.$store.dispatch('Auth/saveToken', { token: newToken })
				this.routeToDashboard()
			},

			routeToDashboard() {
				$('#mfa-validation-modal').modal('hide')
				this.$router.push({ name: 'dashboard' })
			},
			close() {
				this.$emit('close')
			},
			resetWarningsAndErrors() {
				this.ajaxError.errors = []
				this.ajaxWarnings = {}
			},
			validateConfigOTP() {
				this.resetWarningsAndErrors()
				this.stateChangeKey += 1
				this.formStatus = true
				const errorObject = {
					status: 'error',
					message: this.$t('The given data was invalid.'),
					errors: {},
				}
				this.stateChangeKey += 1

				if (!this.isOtpValid) {
					Object.assign(errorObject.errors, {
						otp: [this.$t('Invalid code format')],
					})
					this.formStatus = false
				}

				Object.assign(this.ajaxError, errorObject)

				if (this.formStatus) {
					const otpPayload = {
						totp: this.otp?.trim(),
						ttl_days: CONSTANTS.MFA.DEFAULT_TTL_DAYS, // maximum ttl days
						ttl_start: Math.floor(Date.now() / 1000),
					}
					axios
						.post(helper.removePrefix(this.nextRoute, '/api/'), otpPayload, {
							baseURL: configSettings.authApiUrl,
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						})
						.then(response => {
							this.updateTokenAfterCodeVerification(response.data.token)
						})
						.catch(error => {
							this.$logError(error.response.data)
							if (error.response.status === 401) {
								Object.assign(errorObject.errors, {
									otp: [this.$t(`Session expired. Please log in again`)],
								})
							} else if (error.response.status === 400) {
								Object.assign(errorObject.errors, {
									otp: [this.$t(error.response.data.status)],
								})
							}

							this.ajaxError = { ...errorObject }
							this.stateChangeKey += 1
						})
						.finally(() => {
							this.loading = false
						})
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.mfa-modal-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		line-height: normal;
		color: var(--stan-text-dark-color);

		.modal-pretext {
			margin: 5px;
		}
	}
</style>
